import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { viatorFieldsMap } from '../../fields/touroperators/viator.fields';
import {xolaFieldsMap} from "../../fields/touroperators/xola.fields";

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	xolaFieldsMap.get('enabled'),
	xolaFieldsMap.get('parameters.seller_id'),
	xolaFieldsMap.get('parameters.use_incoming_prices'),
	xolaFieldsMap.get('entity_customer.entity_customer_id'),
	xolaFieldsMap.get('entity_customer.description'),
	xolaFieldsMap.get('branch.branch_id'),
	xolaFieldsMap.get('branch.code'),
	xolaFieldsMap.get('scenario'),
];

const xolaForm: IFormConfig = {
	editTitle: 'Modifica Configurazioni Xola',
	fields: formFields
};

export default xolaForm;
